import React, { useLayoutEffect, useRef, useState } from "react";
import Footer from "../Footer/Footer";
import GetInTouch from "../GetInTouch/GetInTouch";
import Landing from "../Landing/Landing";
import MenuSection from "../MenuSection/MenuSection";
import NavbarMenu from "../NavbarMenu/NavbarMenu";
import PhotoGallery from "../PhotoGallery/PhotoGaller";
import VideoGallery from "../VideoGallery/VideoGallery";
import HomeModal from "../HomeModal/HomeModal";
//
import "./Home.css";
import NewNavbar from "../NavBar/NewNavbar";
function Home() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isShow, steIsShow] = useState(false);
  const [isModal, setIsModal] = useState(true);
  const handleScroll = (e) => {
    if (e.target.scrollTop > 0 && !isScrolled) {
      setIsScrolled(true);
    }
    if (e.target.scrollTop === 0) {
      setIsScrolled(false);
    }
  };
  const handleClick = () => {
    steIsShow(!isShow);
    console.log(isShow);
  };
  const handleClose = () => {
    setIsModal(false);
  };
  return (
    <div className="home_main" onScroll={handleScroll}>
      <NewNavbar handleClick={handleClick} />

      {/* <Navbar isScrolled={isScrolled} handleClick={handleClick} /> */}
      <NavbarMenu isShow={isShow} handleClick={handleClick} />
      <Landing video={true} />
      <p
        className="school_name"
        style={{ color: "#0076bd", textAlign: "center" }}
      >
        HGS Bhopal
      </p>
      <MenuSection />
      {/* <Inspired /> */}
      <GetInTouch />
      <PhotoGallery />
      <VideoGallery />
      <Footer />
      {/* <HomeModal show={isModal} onHide={handleClose} /> */}
    </div>
  );
}

export default Home;
